Object.defineProperty(exports, "__esModule", {
  value: true
});

var _crossFetch = require('cross-fetch');

var _crossFetch2 = _interopRequireDefault(_crossFetch);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var fetchGraphQL = function fetchGraphQL(graphQLUrl, url, credentials, app, query) {
  var fetchUrl = credentials ? url.replace('//', '//' + credentials + '@') : url;
  return (0, _crossFetch2.default)(graphQLUrl, {
    method: 'POST',
    body: '\n\t\t\tquery{\n\t\t\t\telastic50(host: "' + fetchUrl + '"){\n\t\t\t\t\tmsearch(\n\t\t\t\t\t\tindex: "' + app + '"\n\t\t\t\t\t\tbody: ' + JSON.stringify(query.map(function (item) {
      return JSON.stringify(item);
    })) + '\n\t\t\t\t\t)\n\t\t\t\t}\n\t\t\t}\n\t\t',
    headers: {
      'Content-Type': 'application/graphql'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (jsonRes) {
    return jsonRes.data.elastic50.msearch;
  }).catch(function (error) {
    console.error(error);
  });
};

exports.default = fetchGraphQL;